import { render, staticRenderFns } from "./HRMSyncConfig.vue?vue&type=template&id=bf4f3cbc"
import script from "./HRMSyncConfig.vue?vue&type=script&lang=js"
export * from "./HRMSyncConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports